export const sectionHeading = (theme: any) => ({
    fontSize: '0.875rem',
    textTransform: 'uppercase' as const,
    letterSpacing: '0.04em',
    textAlign: 'left' as const,
    color: theme.palette.common.darkGrey,
    opacity: 0.6,
    margin: 0,
});
